const UserFeatureTagsModel = Backbone.Model.extend({
  sync(method, model, options) {
    let params = null;

    if (method === 'read') {
      // Copy the "options" argument minus properties specified in the omit array
      params = _.omit($.extend(true, {}, options), ['parse', 'success', 'error']);

      Sendible.Connect.getFeatureTags('', $username, $password, params, (data) => {
        options.success(data);
      }, () => {
        options.error();
      });
    }
  },
});

export default UserFeatureTagsModel;
